import React, { useState } from 'react';
import { AlternateEmailOutlined, LockOpenOutlined } from '@mui/icons-material';
import AuthLayout from 'layout/auth';
import { Link } from 'react-router-dom';
import { routes } from 'routes';
import AuthModel from 'models/AuthModel';
import { Button, FormControl, Grid, InputAdornment, TextField } from '@mui/material';


export default function Login(){
  
  const [ inputs, setInputs ] = useState({
    email: "",
    password: ""
  });

  const handleChange = (name:string) => (event:any) => {
    handleChangeValue(name)(event.target.value);
  };

  const handleChangeValue = (name:string) => (value:any) => {
    let _inputs = inputs as any;
    _inputs[name] = value;
    setInputs({..._inputs});
  }

  const onSumbut = (e:any) => {
    e.preventDefault();
    AuthModel.auth(inputs.email, inputs.password);
  }

  return (
    <AuthLayout>
      <React.Fragment>
        <form onSubmit={onSumbut}>
          <FormControl fullWidth>
            <TextField
              placeholder="E-mail"
              value={ inputs.email || '' }
              type="email"
              onChange={handleChange('email')}
              margin="normal"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AlternateEmailOutlined color={'action'} />
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              placeholder="Пароль"
              value={ inputs.password || '' }
              type="password"
              onChange={handleChange('password')}
              margin="normal"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockOpenOutlined color={'action'} />
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>

          <Grid container sx={{mt: 2}} justifyContent="space-between" alignItems="center">
            <Grid item>
              <Button
                component={Link}
                to={routes.password}
                size="small"
                color="primary"
              >
                Забув пароль?
              </Button>
            </Grid>
            <Grid item>
              <Button
                size="small"
                color="primary"
                variant="contained"
                type="submit"
              >
                Вхід
              </Button>
            </Grid>
          </Grid>
        </form>
      </React.Fragment>
    </AuthLayout>
  )
}